// Default options that should be included in all fetch requests
export default {
  // Explicitly set same-origin for credentials so that auth cookie works on older browsers
  credentials: 'same-origin'
};
